import type React from "react";
import { Box, Grid, Typography, Skeleton } from "@mui/material";
import { DesignCard } from "./DesignCard";
import type { DesignResponse } from "../types/figma";

interface DesignGridProps {
  designs: DesignResponse[];
  isLoading?: boolean;
  fetchDesigns: (categoryId?: number | null) => Promise<void>;
}

export const DesignGrid: React.FC<DesignGridProps> = ({
  designs,
  isLoading = false,
  fetchDesigns,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ p: 8, minHeight: "calc(100vh - 440px)" }}>
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map((i) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={i}>
              <Skeleton
                variant="rectangular"
                height={320}
                sx={{ borderRadius: 4 }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  if (designs.length === 0) {
    return (
      <Box
        sx={{
          p: 8,
          minHeight: "calc(100vh - 440px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          No designs found for this category
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 8,
        minHeight: "calc(100vh - 440px)",
      }}
    >
      <Grid container spacing={3}>
        {designs.map((design, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={design.id}>
            <DesignCard
              design={design}
              index={index}
              fetchDesigns={fetchDesigns}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
